import { RetailOrderDetails } from "./RetailOrderDetails";

export interface UpdateRetailOrderParams {
	ro: RetailOrderDetails,
	updateType: RetailOrderUpdateType
}

export enum RetailOrderUpdateType {
	Info,
	CustomerContact,
	ReadyToMeasureOrTemplate,
	Template,
	Schedule,
	Install,
	ActualMeasure,
	POReceived,
	PlumbingSchedule,
	InstallStart,
	LowerCabinets,
	InstallCompletion
}
